export default {
	errorAssigningTeam: "An error has occurred while assigning a meeting to a team. Please try again.",
	errorUnassigningTeam: "An error has occurred while unassigning a meeting from a team. Please try again.",
};
